/* divin-cart-reco.js : replie "Complete the look" du tiroir panier quand les articles debordent
   etat sur <html data-divin-reco="collapsed">, lu par divin-overrides.css §7.14
   NATIVE: chaque maj du panier re-rend la section par morph (section-renderer.js), qui recopie
   les attributs du HTML serveur : un etat pose dans le tiroir saute a chaque ajout
   NATIVE: product-recommendations recharge ses recos a tout changement d'attribut sur lui-meme,
   d'ou aucun attribut pose sur lui
   sans ce fichier le bloc reste deplie, comportement natif */
(function () {
  var ROOT = document.documentElement;
  var ATTR = "data-divin-reco";
  var MEASURE = "data-divin-reco-measure";

  // choix du visiteur, prioritaire sur l'auto jusqu'a la fermeture du tiroir ou un changement de quantite
  var manual = null;
  var lastCount = null;
  var lastOpen = false;

  function q(sel) {
    return document.querySelector(".dialog--cart-drawer " + sel);
  }

  function isCollapsed() {
    return ROOT.getAttribute(ATTR) === "collapsed";
  }

  // A11Y: role et etat reposes apres chaque morph, qui retire tout attribut absent du HTML serveur
  function syncTitle() {
    var title = q(".cart-drawer__recommendation-heading .h5");
    if (!title) return;
    var expanded = isCollapsed() ? "false" : "true";
    // garde d'egalite : un setAttribute identique notifie quand meme l'observer
    if (title.getAttribute("role") !== "button") title.setAttribute("role", "button");
    if (title.getAttribute("tabindex") !== "0") title.setAttribute("tabindex", "0");
    if (title.getAttribute("aria-expanded") !== expanded) title.setAttribute("aria-expanded", expanded);
  }

  function setCollapsed(on) {
    if (on) {
      ROOT.setAttribute(ATTR, "collapsed");
    } else {
      ROOT.removeAttribute(ATTR);
    }
    syncTitle();
  }

  // hauteur reelle des cartes pour animer max-height sans borne arbitraire
  // scrollHeight donne le contenu meme replie a max-height 0
  function storeHeight() {
    var products = q(".cart-drawer__recommendation-products");
    if (products && products.scrollHeight) {
      ROOT.style.setProperty("--divin-reco-h", products.scrollHeight + "px");
    }
  }

  function itemCount() {
    var el = q('[ref="cartItemCount"]');
    return el ? el.textContent.trim() : "0";
  }

  // mesure toujours faite deplie, sinon replier libere la place, plus de debordement, et le bloc se rouvre en boucle
  // transitions coupees le temps de la mesure et etat final pose dans la meme frame : aucun rendu intermediaire
  function auto() {
    var items = q(".cart-drawer__items");
    if (!items || !q(".cart-drawer__recommendation")) return;
    ROOT.setAttribute(MEASURE, "");
    ROOT.removeAttribute(ATTR);
    storeHeight();
    setCollapsed(items.scrollHeight > items.clientHeight + 1);
    void items.offsetHeight;
    ROOT.removeAttribute(MEASURE);
  }

  function apply() {
    storeHeight();
    if (manual) {
      setCollapsed(manual === "closed");
    } else {
      auto();
    }
  }

  function onMutate(records) {
    var dialog = document.querySelector(".dialog--cart-drawer");
    var open = !!(dialog && dialog.open);
    var count = itemCount();

    if (!open) {
      if (lastOpen) manual = null;
      lastOpen = false;
      lastCount = count;
      return;
    }

    var opened = !lastOpen;
    var countChanged = count !== lastCount;
    var structural = records.some(function (r) {
      return r.type === "childList";
    });
    if (countChanged) manual = null;
    lastOpen = true;
    lastCount = count;

    if (opened || countChanged || structural) {
      apply();
    } else {
      syncTitle();
    }
  }

  function toggle() {
    storeHeight();
    manual = isCollapsed() ? "open" : "closed";
    setCollapsed(manual === "closed");
  }

  function init() {
    var dialog = document.querySelector(".dialog--cart-drawer");
    if (!dialog) return;
    var section = dialog.closest(".shopify-section") || dialog.parentNode;
    lastCount = itemCount();

    // PERF: attributeFilter, sinon le swiper des recos notifie a chaque frame de glisse
    // open = ouverture du tiroir, les 3 autres = retrait de nos attributs par le morph
    new MutationObserver(onMutate).observe(section, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["open", "role", "tabindex", "aria-expanded"],
    });

    var pending = false;
    window.addEventListener("resize", function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (dialog.open) apply();
      });
    });

    // toute la rangee de titre est cliquable, hors fleches du carrousel
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      if (!e.target.closest(".dialog--cart-drawer .cart-drawer__recommendation-heading")) return;
      if (e.target.closest(".carousel__controls")) return;
      toggle();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      if (!e.target.matches || !e.target.matches(".dialog--cart-drawer .cart-drawer__recommendation-heading .h5")) return;
      e.preventDefault();
      toggle();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
